import React, { useEffect, useState } from 'react';
import {
  ChakraProvider,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  extendTheme,
} from '@chakra-ui/react';
import { clearDependentFields } from 'utils/vehicleFieldUtils';
import VehicleSearchForm from './VehicleSearchForm';
import SearchListModal from './SearchListModal';

const lightTheme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
});

export default function ChooseCarModel({
  isVisible,
  onClose,
  onConfirm,
  selectedValues = {},
  onValueChange,
  onError,
  errorMessage,
  showCancelButton = true,
  confirmButtonText = 'Confirm',
  slideUpPanelTitle = 'Search by Vehicle',
  isConfirmButtonDisabled = false,
  onLpnSearch,
  allowClose = true,
  isLpnSearching = false,
}) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownTitle, setDropdownTitle] = useState('');

  useEffect(() => {
    if (!isVisible) {
      setActiveDropdown(null);
      setDropdownData([]);
      setDropdownTitle('');
    }
  }, [isVisible]);

  const handleModalClose = () => {
    if (!allowClose) {
      return;
    }

    onClose();
  };

  const handleDropdownOpen = (field, data, title) => {
    setActiveDropdown(field);
    setDropdownData(data);
    setDropdownTitle(title);
  };

  const handleDropdownClose = () => {
    setActiveDropdown(null);
    setDropdownData([]);
    setDropdownTitle('');
  };

  const handleSelectItem = (item) => {
    if (!activeDropdown) {
      return;
    }

    clearDependentFields(activeDropdown, onValueChange);
    onValueChange(activeDropdown, item.value);

    if (activeDropdown === 'modification') {
      onValueChange('oemUrl', item.oemUrl || '');
    }

    handleDropdownClose();
  };

  const handleConfirm = (values) => {
    onConfirm(values);
  };

  return (
    <ChakraProvider theme={lightTheme}>
      <Modal
        isOpen={isVisible}
        onClose={handleModalClose}
        size="md"
        isCentered
        closeOnOverlayClick={allowClose}
        closeOnEsc={allowClose}
      >
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent
          bg="white"
          color="gray.800"
          borderRadius="xl"
          overflow="hidden"
        >
          {allowClose && <ModalCloseButton top={4} color="gray.600" />}
          <ModalHeader
            bg="white"
            color="#0F2137"
            fontWeight="700"
            borderBottom="1px solid"
            borderColor="gray.200"
            py={4}
            pr={12}
          >
            {slideUpPanelTitle}
          </ModalHeader>
          <ModalBody pb={6} bg="white" color="gray.800">
            <VehicleSearchForm
              onCancel={handleModalClose}
              onConfirm={handleConfirm}
              selectedValues={selectedValues}
              onValueChange={onValueChange}
              onDropdownOpen={handleDropdownOpen}
              onError={onError}
              showCancelButton={showCancelButton}
              confirmButtonText={confirmButtonText}
              isConfirmButtonDisabled={isConfirmButtonDisabled}
              errorMessage={errorMessage}
              onLpnSearch={onLpnSearch}
              isLpnSearching={isLpnSearching}
            />

            <SearchListModal
              modalHeading={dropdownTitle}
              options={dropdownData}
              isOpen={Boolean(activeDropdown)}
              onClose={handleDropdownClose}
              onSelect={handleSelectItem}
              selectedValue={activeDropdown ? selectedValues[activeDropdown] : null}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
}
